<div class="detail-page">
  <div app-kirjanpito-projektien-tyylit [kirjanpidonProjektitObservable]="kirjanpidonProjektitObservable"></div>
  <app-asiakas-otsikko otsikko="Tositteen tiedot" [naytaPalaa]="true" [paluuUrl]="paluuUrl" [asiakas]="asiakas"></app-asiakas-otsikko>

  @if (naytaDebug()) {
    <div class="light-gray-text" style="margin-bottom: 2em">
      Kuitin tekstuaalinen data Firestore: <a [href]="kuittiDataFirestoreUrl" target="_BLANK">{{ kuittiDataFirestoreUri }}</a> <br />Kuitin tekstuaalinen data RealtimeDb: <a [href]="kuittiDataRealtimeDbUrl" target="_BLANK">{{ kuittiDataRealtimeDbUri }}</a> <br />Kuitin binääridata Firebase: <a [href]="binaryDataUrlFirebase" target="_BLANK">Avaa</a> <br />Kuitin binääridata Google Cloud:
      <a [href]="binaryDataUrlGCP" target="_BLANK">Avaa</a> <br /><br />Mahdollinen kirjattava kuitti: <a [href]="kirjattavaKuittiDataFirestoreUrl" target="_BLANK">{{ kirjattavaKuittiDataFirestoreUri }}</a>
      <div style="margin: 10px 5px">
        <app-secondary-button (click)="reloadTosite()" actionId="Käynnistä tositteen tuonti Lemonaidista uudelleen"> Käynnistä tositteen tuonti Lemonaidista uudelleen </app-secondary-button>
      </div>
    </div>
  }

  <div class="otsake-container">
    <div class="otsake">
      <div>
        <span>{{ 'kuitit.katsele.tosite' | translate | async }}</span>
        <h2 class="light-blue-text">{{ otsakeObservable | async }}</h2>
      </div>
      <!-- <div *ngIf="naytaTavallinenOtsake()">
      <span>{{'lasku.katsele-muokattava-dialog.lasku' | translate | async}}</span>
      <h2 class="light-blue-text">{{laskuSharedService.annaMuotoiltuLaskunumero(kasiteltava)}} {{kasiteltava?.asiakas?.nimi}}</h2>
    </div>
    <div *ngIf="naytaMaksuaikaa()">
      <span>{{'lasku.katsele-muokattava-dialog.maksuaikaa' | translate | async}}</span>
      <h2 [class.light-blue-text]="annaMaksuaikaa() > -1" [class.red-text]="annaMaksuaikaa() < 0">{{annaMaksuaikaa()}} pv</h2>
    </div> -->
      <div>
        <span>{{ 'kuitit.katsele.summa' | translate | async }}</span>
        <h2 class="blue-text">{{ tosite?.sum ?? tosite?.summa | lmoney: 'EUR' | async }}</h2>
      </div>
    </div>
  </div>

  <!-- <div class="nappula-container">
<div class="nappulat">
  <button mat-button class="secondarybutton" (click)="lataaKuitti()">
    <span>{{ 'kuitit.katsele.lataa' | translate | async }}</span>
  </button>
</div>
</div> -->

  <div>{{ tosite?.selite }}</div>
  @if (tosite.userApiMessage) {
    <div class="tosite-api-msg" style="margin-top: 1em">{{ tosite.userApiMessage }}</div>
  }
  @if (projektiObservable | async; as projekti) {
    <div class="projekti">
      <span [class]="'a' + projekti.avain + ' kr-projekti-dot projekti-pallo'"></span>
      <span>{{ projekti.nimi }}</span>
    </div>
  }
  <!-- <div *ngIf="tosite?.alvVahennysoikeus !== null">{{'kuitit.katsele.alv' | translate | async}} {{ tosite?.alvVahennysoikeus }} %</div> -->

  @if (naytaDebug() && alkuperaiset) {
    <div class="alkuperaiset-container light-gray-text">
      <h3 style="margin: 2em 0 0 0">Alkuperäiset tiedostot</h3>
      @for (alkuperainen of alkuperaiset; track alkuperainen) {
        <div style="margin-bottom: 1em">
          {{ alkuperainen.nimi }}
          <app-secondary-button (click)="lataaAlkuperainen(alkuperainen)" actionId="Lataa alkuperäinen tositteen tiedosto koneelle">
            <span>Lataa tiedosto</span>
          </app-secondary-button>
        </div>
      }
    </div>
  }

  <div class="tosite-sivut">
    @for (kuvat of ryhmitetytKuvat; track $index) {
      @if (kuvat.length > VIRTUAL_SCROLL_THRESHOLD) {
        <cdk-virtual-scroll-viewport class="tosite-sivut-viewport" [itemSize]="sivunKorkeus" minBufferPx="1200" maxBufferPx="2400">
          <div *cdkVirtualFor="let kuva of kuvat; trackBy: trackKuva" class="tosite-sivu" [class.poistettu-kuva]="kuva.poistettu" [style.height.px]="sivunKorkeus">
            <img [src]="kuva.safeUrl" (load)="kuvanLataaminenValmis(kuva)" (error)="kuvanLataaminenValmis(kuva)" crossorigin="use-credentials" class="mat-elevation-z4" />
            <div lemon-loading [show]="kuva.ladataan"></div>
          </div>
        </cdk-virtual-scroll-viewport>
      } @else {
        @for (kuva of kuvat; track kuva.avain) {
          <div class="tosite-sivu" [class.poistettu-kuva]="kuva.poistettu">
            <div class="kuva-container" style="position: relative; width: 100%; min-height: 196px; margin-top: 2em">
              <img [src]="kuva.safeUrl" loading="lazy" (load)="kuvanLataaminenValmis(kuva)" (error)="kuvanLataaminenValmis(kuva)" crossorigin="use-credentials" class="mat-elevation-z4" style="max-width: 100%; margin-top: 15px" />
              <div lemon-loading [show]="kuva.ladataan"></div>
            </div>
          </div>
        }
      }
    }
  </div>
</div>
